import React, { useEffect, useImperativeHandle, useState } from "react";
import { Avatar } from "../../Avatar/Avatar";
import { visibleScrollbar } from "../../../utils/functions/get-visible-scrollbar";
import { MentionListProps } from "../utils/types/types";

const MentionList: React.FC<MentionListProps> = ({ items, command, ref }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const selectItem = (index: number): void => {
    const item = items[index];

    if (item) {
      command({ id: item._id, label: item.name });
    }
  };

  const upHandler = (): void => {
    setSelectedIndex((selectedIndex + items.length - 1) % items.length);
  };

  const downHandler = (): void => {
    setSelectedIndex((selectedIndex + 1) % items.length);
  };

  const enterHandler = (): void => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: { event: KeyboardEvent }): boolean => {
      if (event.key === "ArrowUp") {
        upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        downHandler();
        return true;
      }

      if (event.key === "Enter") {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div
      data-mention-portal
      className={`flex flex-col w-[200px] max-h-[190px] overflow-y-auto bg-popper-bg dark:bg-popper-bg-dk border border-border-gray dark:border-border-gray-dk rounded-[8px] shadow-popper-blur-effect backdrop-blur-[10px] ${visibleScrollbar(
        "[&::-webkit-scrollbar]:h-[8px] [&::-webkit-scrollbar]:w-[8px]"
      )}`}
    >
      {items.length ? (
        items.map((item, index) => (
          <button
            className={`px-[12px] py-[10px] hover:bg-hover-effect dark:hover:bg-hover-effect-dk cursor-pointer
              ${index === selectedIndex && "is-selected"}
            `}
            key={index}
            onClick={() => selectItem(index)}
          >
            <div className="flex items-center gap-[5px]">
              {item.profile_picture ? (
                <img
                  src={item.profile_picture}
                  alt={item.name}
                  className="w-6 h-6 rounded-full"
                />
              ) : (
                <Avatar text={item.name} size={24} />
              )}

              <p className="font-medium text-md text-heading-text dark:text-heading-text-dk">
                {item.name}
              </p>
            </div>
          </button>
        ))
      ) : (
        <p className="px-[12px] py-[10px] text-center font-medium text-md text-heading-text dark:text-heading-text-dk">
          No users found
        </p>
      )}
    </div>
  );
};

export default MentionList;
